/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: template.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateTemplateRequest,
  CreateTemplateResponse,
  DeleteTemplateRequest,
  DeleteTemplateResponse,
  GetTemplateRequest,
  GetTemplateResponse,
  ListTemplatesRequest,
  ListTemplatesResponse,
  RenderTemplateRequest,
  RenderTemplateResponse,
  UpdateTemplateRequest,
  UpdateTemplateResponse,
} from '../types/template';

export const createTemplateService = (transport: Transport) => ({
  async createTemplate(
    request: CreateTemplateRequest,
    options: RequestOptions = {},
  ): Promise<CreateTemplateResponse> {
    const { organization_id, ...body } = request;
    const url = getApiPath(API_METHODS.TemplateService.CreateTemplate, { organization_id });
    return transport.post<CreateTemplateResponse>(url, body, options);
  },

  async getTemplate(
    request: GetTemplateRequest,
    options: RequestOptions = {},
  ): Promise<GetTemplateResponse> {
    const { organization_id, template_id } = request;
    const url = getApiPath(API_METHODS.TemplateService.GetTemplate, {
      organization_id,
      template_id,
    });
    return transport.get<GetTemplateResponse>(url, options);
  },

  async updateTemplate(
    request: UpdateTemplateRequest,
    options: RequestOptions = {},
  ): Promise<UpdateTemplateResponse> {
    const { organization_id, template_id, ...body } = request;
    const url = getApiPath(API_METHODS.TemplateService.UpdateTemplate, {
      organization_id,
      template_id,
    });
    return transport.post<UpdateTemplateResponse>(url, body, options);
  },

  async deleteTemplate(
    request: DeleteTemplateRequest,
    options: RequestOptions = {},
  ): Promise<DeleteTemplateResponse> {
    const { organization_id, template_id } = request;
    const url = getApiPath(API_METHODS.TemplateService.DeleteTemplate, {
      organization_id,
      template_id,
    });
    return transport.delete<DeleteTemplateResponse>(url, options);
  },

  async listTemplates(
    request: ListTemplatesRequest,
    options: RequestOptions = {},
  ): Promise<ListTemplatesResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.TemplateService.ListTemplates, { organization_id });
    return transport.get<ListTemplatesResponse>(url, { params, ...options });
  },

  async renderTemplate(
    request: RenderTemplateRequest,
    options: RequestOptions = {},
  ): Promise<RenderTemplateResponse> {
    const { organization_id, template_id, ...body } = request;
    const url = getApiPath(API_METHODS.TemplateService.RenderTemplate, {
      organization_id,
      template_id,
    });
    return transport.post<RenderTemplateResponse>(url, body, options);
  },
});

export type TemplateService = ReturnType<typeof createTemplateService>;
